import React, { useEffect, useRef } from "react";
import "./CommentContextMenu.css";
import archiveIcon from "../../assets/archive.svg";
import ReactDOM from "react-dom";
import deleteIcon from "../../assets/delete.svg";
import { useSelector } from "react-redux";
import editIcon from "../../assets/edit.svg";
import { userSelector } from "../../store/selectors";
import { ReactComponent as DeleteIcon } from "../../assets/delete-color.svg";
import { ReactComponent as EditIcon } from "../../assets/edit-color.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/archive-color.svg";

const CommentContextMenu = ({
  isOpen,
  isReply = false,
  onClose,
  onArchive,
  onRestore = () => {},
  onDelete,
  onEdit,
  onForceDelete,
  position,
  isArchived,
  comment,
  contextMenuPosition,
}) => {
  const menuRef = useRef(null);
  const user = useSelector(userSelector);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const menu = (
    <div
      className="comment-context-menu"
      ref={menuRef}
      style={{
        position: "absolute",
        top: contextMenuPosition.top,
        left: contextMenuPosition.left,
        zIndex: 2000,
        width: 140,
      }}
    >
      {comment.author.id === user.userId && (
        <div
          className="comment-context-menu-item"
          onClick={() => {
            onEdit();
            onClose();
          }}
        >
          <EditIcon
            style={{
              stroke: "#9a6aff",
              color: "#9a6aff",
            }}
          />
          <span>Редактировать</span>
        </div>
      )}
      {comment.timecode !== null && !isReply && (
        <div
          className="comment-context-menu-item"
          onClick={() => {
            if (isArchived) {
              onRestore();
            } else {
              onArchive();
            }
            onClose();
          }}
        >
          <ArchiveIcon
            style={{
              stroke: "#79c979",
              color: "#79c979",
            }}
          />
          <span>{isArchived ? "Вернуть" : "Решено"}</span>
        </div>
      )}
      <div
        className="comment-context-menu-item"
        onClick={() => {
          onForceDelete();
          onClose();
        }}
      >
        <DeleteIcon
          style={{
            stroke: "#f44343",
            color: "#f44343",
          }}
        />
        <span>Удалить</span>
      </div>
    </div>
  );

  return ReactDOM.createPortal(menu, document.body);
};

export default CommentContextMenu;
